import React, {
  Dispatch,
  useState,
  forwardRef,
  SetStateAction,
  useImperativeHandle,
  ForwardRefRenderFunction,
} from 'react';
import Step from '@mui/material/Step';
import Stepper from '@mui/material/Stepper';
import StepButton from '@mui/material/StepButton';
import StepConnector from '@mui/material/StepConnector';

const steps = [
  'Details',
  'Target Criteria',
  'Rules',
  'Instances Creation Criteria',
  'Output',
];

interface Props {
  onStepClick: (step: number) => void;
}

export interface Ref {
  activeStep: number;
  setActiveStep: Dispatch<SetStateAction<number>>;
}

const FormStepper: ForwardRefRenderFunction<Ref, Props> = (
  { onStepClick },
  ref
) => {
  const [activeStep, setActiveStep] = useState<number>(0);

  useImperativeHandle(ref, () => ({
    activeStep,
    setActiveStep,
  }));

  return (
    <Stepper
      activeStep={activeStep}
      connector={<StepConnector className="stepper-connector" />}
      className="stepper"
      nonLinear
      orientation="vertical"
    >
      {steps.map((label, index) => (
        <Step key={label}>
          <StepButton disableRipple onClick={() => onStepClick(index)}>
            {label}
          </StepButton>
        </Step>
      ))}
    </Stepper>
  );
};

export default forwardRef<Ref, Props>(FormStepper);
